import {
	BENEFICIARY_TYPE,
	SHOW_MODAL_ADD_BENEFICIARIES,
	ADD_BENEFICIARY,
	CLEAN_BENEFICIARIES,
	UPDATE_BENEFICIARIES,
} from '../types/beneficiaries';

export const setBeneficiaryType = (value) => ({
	type: BENEFICIARY_TYPE,
	payload: value,
});

export const showModalAddBeneficiaries = (value) => ({
	type: SHOW_MODAL_ADD_BENEFICIARIES,
	payload: value,
});

export const addBeneficiary = (value) => ({
	type: ADD_BENEFICIARY,
	payload: value,
});

export const updateBeneficiaries = (value) => ({
	type: UPDATE_BENEFICIARIES,
	payload: value,
});

export const cleanBeneficiaries = () => ({
	type: CLEAN_BENEFICIARIES,
});
